import React from "react";
import TextSlicer from "../../components/TextSlicer";
import { Card, Row, Col, CardBody, Container } from "reactstrap";
import { useThemeImage } from "../../components/Hooks/useThemeImage";
import {
  cumstomerImg1,
  cumstomerImg2,
  cumstomerImg3,
  cumstomerImg4,
  cumstomerImg5,
  cumstomerImg6,
  cumstomerImg7,
  cumstomerImg8,
  cumstomerImg9,
  cumstomerImg10,
  cumstomerImg11,
  cumstomerImg12,
  cumstomerImg13,
  cumstomerImg14,
  cumstomerImg15,
  cumstomerImg16,
  cumstomerImg17,
  cumstomerImg18,
  cumstomerImg19,
  cumstomerImg20,
  cumstomerImg21,
  cumstomerImg22,
  cumstomerImg23,
  cumstomerImg24,
  cumstomerImg25,
  cumstomerImg26,
  cumstomerImg27,
  cumstomerImg28,
  cumstomerImg29,
  cumstomerImg30,
  cumstomerImg31,
  cumstomerImg32,
  cumstomerImg33,
  cumstomerImg34,
  cumstomerImg35,
  cumstomerImg36,
  cumstomerImg37,
  cumstomerImg38,
  cumstomerImg39,
  cumstomerImg40,
  cumstomerImg41,
  cumstomerImg42,
  cumstomerImg43,
  cumstomerImg44,
  cumstomerImg45,
  cumstomerImg46,
  cumstomerImg47,
  cumstomerImg48,
  cumstomerImg49,
} from "../../images";
import MetaData from "../../components/MetaData";
import GoogleReviewSection from "../../components/GoogleReviewSection";
import "../../views/sass/customer.scss";
const description = `At Softorithm, we pride ourselves on providing exceptional web development, graphic design, UI/UX design, and digital marketing services through our team of passionate professionals. We take great satisfaction in offering innovative solutions to satisfy the particular requirements of our esteemed clients. Together, we can improve user experiences, boost your online visibility, and help you succeed in the digital sphere.`;

const images = [
  cumstomerImg1,
  cumstomerImg2,
  cumstomerImg3,
  cumstomerImg4,
  cumstomerImg5,
  cumstomerImg6,
  cumstomerImg7,
  cumstomerImg8,
  cumstomerImg9,
  cumstomerImg10,
  cumstomerImg11,
  cumstomerImg12,
  cumstomerImg13,
  cumstomerImg14,
  cumstomerImg15,
  cumstomerImg16,
  cumstomerImg17,
  cumstomerImg18,
  cumstomerImg19,
  cumstomerImg20,
  cumstomerImg21,
  cumstomerImg22,
  cumstomerImg23,
  cumstomerImg24,
  cumstomerImg25,
  cumstomerImg26,
  cumstomerImg27,
  cumstomerImg28,
  cumstomerImg29,
  cumstomerImg30,
  cumstomerImg31,
  cumstomerImg32,
  cumstomerImg33,
  cumstomerImg34,
  cumstomerImg35,
  cumstomerImg36,
  cumstomerImg37,
  cumstomerImg38,
  cumstomerImg39,
  cumstomerImg40,
  cumstomerImg41,
  cumstomerImg42,
  cumstomerImg43,
  cumstomerImg44,
  cumstomerImg45,
  cumstomerImg46,
  cumstomerImg47,
  cumstomerImg48,
  cumstomerImg49,
];
const Customer = () => {
  const handleButtonClick = () => {
    // Handle button click - you can navigate to a specific page or perform any action
    console.log("See Our Work button clicked");
  };

  return (
    <>
      <MetaData
        metaTitle={"Customer"}
        robots="noindex, nofollow"
        metaDescription={
          "At Softorithm, we pride ourselves on providing exceptional web development, graphic design, UI/UX design, and digital marketing services through our team of passionate professionals."
        }
      />

      {/* Section 1 - Hero */}
      <GoogleReviewSection
        isBest = {false}
        title="What Our Clients Say About Us"
        subtitle="Expert HTML, WordPress, and React.js development services that create fast, responsive, and user-friendly web applications. Trusted by businesses worldwide for over 12 years."
        buttonText="See Our Work"
        onButtonClick={handleButtonClick}
        companyName="Softorithm"
      />

      {/* Industries Section */}
      <div className="page_body">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <h2 className="text-center mb-4" style={{ fontWeight: "bold" }}>
                Industries We Serve
              </h2>
              <Row className="justify-content-center">
                <Col md={6} className="mb-3 industries-column">
                  <Card className="h-100 shadow-sm border-0 industries-card">
                    <CardBody>
                      <ul className="industries-list mb-0">
                        <li>Travel & Hospitality</li>
                        <li>Telecommunication</li>
                        <li>Oil, Gas, and Energy</li>
                        <li>E-commerce</li>
                        <li>Healthcare & Pharmaceuticals</li>
                      </ul>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={6} className="mb-3 industries-column">
                  <Card className="h-100 shadow-sm border-0 industries-card">
                    <CardBody>
                      <ul className="industries-list mb-0">
                        <li>Public Sector</li>
                        <li>Retail & CPG</li>
                        <li>Startups</li>
                        <li>Banking & Fintech</li>
                        <li>Gaming</li>
                      </ul>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>

      <div className="page_body">
        <div className="container ">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-12">
              <div className="about_rgt_cont text-center">
                <h2 className="text-center mb-4">Our Valuable Clients</h2>
                <TextSlicer text={description} />
              </div>
            </div>
            <Row className="justify-content-center mt-4">
              {images.map((image, index) => (
                <CustomerImage key={index} image={image} />
              ))}
            </Row>
          </div>
        </div>
      </div>

      {/* Section 7 - CTA Section */}
      <section className="erp_cta_section">
        <Container>
          <Row className="align-items-center">
            <Col lg={8} md={7} sm={12} className="mb-3 mb-md-0">
              <p className="erp_cta_text">
                Digitalize The Way You Do Your Accounting
              </p>
            </Col>
            <Col lg={4} md={5} sm={12} className="text-center text-md-start">
              <button
                type="button"
                className="erp_cta_btn"
                onClick={handleButtonClick}
              >
                Call Us Today!
              </button>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

// Separate component to use the hook for each image
const CustomerImage = ({ image }) => {
  const themeImage = useThemeImage(image);

  return (
    <Col md={3} sm={6} xs={6}>
      <Card>
        <CardBody className="p-0 text-center">
          <div className="customer_img_bx rounded">
            <img src={themeImage} alt="" className="img-fluid" />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Customer;
